<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">


                <div class="row">
                  <div class="col-md-9">
                    <h2>Dr. Petronela Pascaru – Medic specialist psihiatriu</h2>
                    <div class="other-option md-none mt-40">
                      <a href="/#appointment" class="btn style2">
                        Solicită o programare
                      </a>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="team-card style3">
                      <div class="team-img"> <img src="../../../assets/images/team/member-7.jpg"
                          alt="Dr. Petronela Pascaru – Psihiatrie" /></div>
                    </div>
                  </div>
                </div>

                <p>
                  Sunt <strong>Dr. Petronela Pascaru</strong> medic specialist psihiatru, și cred că sănătatea mintală merită aceeași atenție și grijă ca sănătatea fizică.
Cred în importanța unei abordări individualizate, bazate pe empatie, respect și încredere. În cabinet, fiecare pacient este ascultat și înțeles dincolo de simptome, pentru a putea identifica împreună cele mai potrivite soluții.
Intervenția timpurie poate face o diferență importantă. De aceea, este bine să solicitați sprijin atunci când stările de tristețe, anxietate, neliniște sau epuizare devin persistente ori încep să afecteze somnul, relațiile, activitatea profesională sau viața de zi cu zi.
Ofer evaluare și suport de specialitate pentru o gamă variată de dificultăți psihice și emoționale, printre care se numără tulburările de anxietate, atacurile de panică, tulburările depresive, tulburările de somn, modificările de dispoziție, dificultățile de concentrare, reacțiile la stres și problemele de adaptare, precum și situațiile în care există comportamente adictive sau dificultăți relaționale care afectează echilibrul personal.
A cere ajutor nu este un semn de slăbiciune, ci un pas important către echilibru și o viață mai bună.


                </p>

                <h3>Educație și formare profesională</h3>

                <h3>Experiență profesională</h3>
              </div>
            </div>

          </div>
        </div>
      </div>


    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
// import ServiceDetails from "../../ServiceDetails/ServiceDetails.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "CardiologiePage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    // ServiceDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>